import { GeneralOverview } from "asset-analysis/lib/@types/analysis/utils/general";
import { api } from "../api";

export default async function store(
  data: GeneralOverview,
  encodedId: string
): Promise<boolean> {
  try {
    const { status } = await api.post(`/analysis/${encodedId}/report`, data);

    return status === 201;
  } catch (err) {
    console.log(err);

    return false;
  }
}
